export default __webpack_public_path__ + "static/media/Merriweather-Bold.ae39f743.ttf";